export const READER_TYPOGRAPHY_CHANGE_EVENT = 'reedle:reader-typography-change';
